import { combineReducers } from "redux";

import fcmToken from "./fcmToken";
import introSlides from "./introSlides";
import themeColors from "./themeColors";
import token from "./token";

export default combineReducers({
  fcmToken,
  introSlides,
  themeColors,
  token
});
